import React, { useState } from 'react';
import axios from 'axios';
import { Spinner } from '../design-system';
import styled, { css } from 'styled-components';

import Alert from '../helpers/alert';
import useDownload from '../hooks/use-download';

const FilenameWrapper = styled.span(
  ({ theme }) => css`
    position: relative;
    display: flex;
    color: ${theme.colors.blue};
  `,
);

const NameWrapper = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

interface FileDownloadProps {
  children: React.ReactNode;
  id: string | number;
  filename: string;
  mime: string;
  ERR_MSG: string;
}

export default ({
  children,
  id,
  filename,
  mime,
  ERR_MSG,
}: FileDownloadProps) => {
  const [downloading, setDownloading] = useState(false);
  const download = useDownload();

  const handleFileDownload = async () => {
    // Ignore clicks while a download is already in flight.
    if (downloading) return;
    setDownloading(true);
    try {
      const { data, headers } = await axios(`/file/download/${id}`, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: mime,
        },
      });
      download({
        fileName: filename,
        data,
        headers: headers as Record<string, string>,
      });
      setDownloading(false);
    } catch (error) {
      Alert.error(ERR_MSG);
      setDownloading(false);
    }
  };
  return (
    <FilenameWrapper>
      {downloading && <Spinner size={20} />}
      <NameWrapper style={{}} onClick={handleFileDownload}>
        {children}
      </NameWrapper>
    </FilenameWrapper>
  );
};
